<template>
  <v-dialog v-model="dialog" width="800">
    <v-card>
      <v-card-text>
        <v-btn absolute style="right: 0" class="mt-1" icon @click="close">
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <v-card-title class="px-0">{{ $t("editContract") }}</v-card-title>
        <validation-observer v-slot="{ handleSubmit }">
          <form @submit.prevent="handleSubmit(save)">
            <div class="row row--dense">
              <div class="py-1" style="flex: 0 0 100%">
                {{ $t("contractNumber") }}*
                <custom-input-text
                  v-model="contractData.code"
                  :name="$t('nContract')"
                  :placeholder="$t('contractNumber')"
                  class="user_input no-margin"
                  rules="required"
                >
                </custom-input-text>
              </div>
              <div class="py-1" style="flex: 0 0 100%">
                {{ $t("supplier") }}*
                <vue-select
                  ref="supplierSelectRef"
                  infinite
                  v-model="contractData.supplierId"
                  :get-item-promise="
                    ({ text, page }) =>
                      $store.dispatch('getSuppliers', {
                        name: text,
                        page,
                        limit: 15,
                      })
                  "
                  :items="suppliers"
                  :name="$t('supplier')"
                  :placeholder="$t('supplier')"
                  class="user_input product-select-in-modal flex-grow-1"
                  rules="required"
                  @item-resolved="setSupplier"
                  @next-page-resolved="
                    (data) => setSupplier([...data, ...suppliers])
                  "
                ></vue-select>
              </div>
              <div class="py-1" style="flex: 0 0 100%">
                {{ $t("typeDelivery") }}*
                <custom-select
                  v-model="contractData.supplyType"
                  :item-text="(val) => $t(val.name)"
                  :items="deliveryTypes"
                  :name="$t('typeDelivery')"
                  :placeholder="$t('typeDelivery')"
                  add-class="user_input"
                  class="user_input no-margin"
                  item-value="value"
                  rules="required"
                ></custom-select>
              </div>
              <div class="py-1" style="flex: 0 0 100%">
                {{ $t("contractDate") }}*
                <custom-date-picker
                  v-model="contractData.conclusionDate"
                  :name="$t('contractDate')"
                  class="user_input no-margin"
                  icon="mdi-calendar-month small"
                  rules="required"
                ></custom-date-picker>
              </div>
            </div>
            <div class="text-right pt-4">
              <v-btn type="submit" :loading="loading" color="primary">{{
                $t("save")
              }}</v-btn>
            </div>
          </form>
        </validation-observer>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import VueSelect from "@/components/ui/vue-select/VueSelect";
import { deliveryTypes } from "@/utils/constants";
import {
  addTimeZone,
  getQueryByKey,
  insertDataToFormData,
} from "@/utils/pureFunctions";

const DEFAULT_CONTRACT_DATA = {
  code: null,
  conclusionDate: null,
  supplierId: null,
  supplyType: null,
  id: null,
};
export default {
  name: "OzlContractEditDialog",
  components: { VueSelect },
  data() {
    return {
      suppliers: [],
      dialog: false,
      loading: false,
      contractData: {
        ...DEFAULT_CONTRACT_DATA,
      },
    };
  },
  methods: {
    setSupplier(suppliers) {
      this.suppliers = suppliers;
    },
    clearData() {
      this.contractData = {
        ...DEFAULT_CONTRACT_DATA,
      };
    },
    async save() {
      this.loading = true;
      try {
        const formData = insertDataToFormData(this.contractData);
        await this.$http.post("contract/update", formData);
        this.setSuccess({ text: this.$t("successfullySaved") });
        this.$emit("saved");
        this.dialog = false;
        this.clearData();
      } catch (e) {
        this.setResponseError({ error: e });
      } finally {
        this.loading = false;
      }
    },
    open(data) {
      data = { ...data };
      data.conclusionDate = addTimeZone(
        addTimeZone(data.conclusionDate)
      ).toISOStringWithTimeZone();
      if (!data) throw new Error("contract data not set");
      this.$nextTick(() => {
        setTimeout(() => {
          const { supplierSelectRef } = this.$refs;
          supplierSelectRef.reset();
          const suppliers = [
            {
              id: data.supplierId,
              name: data.supplierName,
            },
          ];
          supplierSelectRef.setCachedItems(suppliers);
          this.suppliers = suppliers;
        }, 100);
      });
      this.contractData = getQueryByKey(DEFAULT_CONTRACT_DATA, data);
      this.dialog = true;
    },
    close() {
      this.dialog = false;
    },
  },
  computed: {
    deliveryTypes: () => deliveryTypes,
  },
};
</script>
